import React, { useRef, useEffect, useState } from "react";
import F2 from "@antv/f2/lib/index-all";
import { useDebounceFn } from 'ahooks';
import _ from 'lodash'
const Canvas = F2.G.Canvas;
const Util = F2.Util
import './shape.ts'

interface Item {
	name: string
	value: number
	color: string
}

interface AiPieProps {
	data: Item[] //图表数据
	html?: string //饼图中间的html
	canvasWidth?: string //图表宽度
	canvasHeight?: string //图表高度
	isRoundedCorners?: boolean //是否需要圆角
	colors?: any
}

const AiPie: React.FC<AiPieProps> = ({ colors = null, data = [], html = ``, canvasWidth = '2.453333rem', canvasHeight = '2.453333rem', isRoundedCorners = true, ...props }) => {
	const myChart = useRef<any>()
	const canvasContainer = useRef<any>()
	let [pirChart, setPirChart] = useState(null)
	const upDate = () => {
		if (pirChart) {
			pirChart.clear(); // 清除
			setPirChart(null)
		}
		const { width, height } = canvasContainer.current.getBoundingClientRect()
		let chart = new F2.Chart({
			id: myChart.current,
			width,
			height,
			pixelRatio: window.devicePixelRatio,
			padding: [0, 0, 0, 0],
			appendPadding: [0, 0, 0, 0]
		});
		const o = data.find(item => !!item.value)
		if (!o) {
			data = [{
				name: 'a',
				value: 1,
				color: '#ddd'
			}]
		}
		chart.source(data, {
			value: {
				formatter: val => val
			}
		});
		chart.tooltip(false);
		chart.legend(false);
		chart.coord('polar', {
			transposed: true,
			innerRadius: 0.85,
			radius: 1
		});
		chart.axis(false);
		// 圆角
		_getRoundedCorners(isRoundedCorners, chart)
		guideHtml(chart, html)
		chart.render();
		setPirChart(chart)
	}
	const { run } = useDebounceFn(upDate,{
		wait: 300
	});
	useEffect(() => {
		if (data.length) {
			run()
		}
	}, [data, html, canvasWidth, canvasHeight, isRoundedCorners, props.children])

	// 圆角
	const _getRoundedCorners = (isRoundedCorners, chart) => {
		if (isRoundedCorners) {
			chart.interval()
				.position('1*value')
				.color('name', data.map(item => item.color))
				.shape('tick')
				.adjust('stack')
				.animate({
					appear: {
						duration: 400,
						easing: 'quadraticOut',
						animation: (shape, animateCfg) => {
							const startAngle = shape.attr('startAngle');
							const endAngle = shape.attr('endAngle');
							shape.attr('endAngle', startAngle);
							shape.animate().to(Util.mix({
								attrs: {
									endAngle
								}
							}, animateCfg)).onUpdate((frame) => {

							});
						}
					}
				});
			return
		}
		chart.interval()
			.position('1*value')
			.color('name', colors || data.map(item => item.color))
			.adjust('stack')
			.animate({
				appear: {
					duration: 400,
					easing: 'quadraticOut',
					animation: 'groupWaveIn'
				}
			});
	}

	const guideHtml = (chart, html: string) => {
		if (!html) {
			return
		}
		const _canvas = new Canvas({
			el: myChart.current
		});
		const _width = _canvas.getWidth() / window.devicePixelRatio
		chart.guide().html({
			position: ['50%', '55%'],
			html: `<div style="text-align: center;width:${_width}px">
					${html}
				  </div>`
		});
	}
	return <div>
		<div ref={canvasContainer} style={{ width: canvasWidth, height: canvasHeight }}>
			<canvas ref={myChart} style={{ width: '100%', height: '100%' }}></canvas>
		</div>
		{props?.children}
	</div>
}

export default AiPie